import {
  KestrelInspectionType,
  KVAnnotation,
  KVG1N6Annotation,
  KVNavyAnnotation,
} from 'types'

export interface SeverityConfiguration {
  possibleValues: string[]
  headerText: string
  getCurrentSeverity: (annotation: KVAnnotation) => string
  setSeverity: (
    annotation: KVAnnotation,
    severity: string,
    setEditedAnnotation: (fn: (prev: KVAnnotation) => KVAnnotation) => void
  ) => void
}

export const severityConfigurations = new Map<
  KestrelInspectionType,
  SeverityConfiguration
>([
  [
    KestrelInspectionType.NAVY,
    {
      possibleValues: ['5', 'N/V'],
      headerText: 'Structural Severity (S#)',
      getCurrentSeverity: (annotation) =>
        annotation.navyAnnotation?.navySeverity || '',
      setSeverity: (annotation, severity, setEditedAnnotation) => {
        setEditedAnnotation((prev) => ({
          ...prev,
          navyAnnotation: {
            ...(prev.navyAnnotation || new KVNavyAnnotation()),
            navySeverity: severity,
          },
        }))
      },
    },
  ],
  [
    KestrelInspectionType.DEFAULT,
    {
      possibleValues: ['1', '2', '3', '4', '5'],
      headerText: 'Severity',
      getCurrentSeverity: (annotation) => annotation.severity,
      setSeverity: (annotation, severity, setEditedAnnotation) => {
        setEditedAnnotation((prev) => ({ ...prev, severity }))
      },
    },
  ],
  [
    KestrelInspectionType.ROOFTOP,
    {
      possibleValues: ['1', '2', '3', '4', '5'],
      headerText: 'Severity',
      getCurrentSeverity: (annotation) => annotation.severity,
      setSeverity: (annotation, severity, setEditedAnnotation) => {
        setEditedAnnotation((prev) => ({ ...prev, severity }))
      },
    },
  ],
  [
    KestrelInspectionType.AEROSPACE,
    {
      possibleValues: ['Minor', 'Moderate', 'Flight Critical', 'Unknown'],
      headerText: 'Severity',
      getCurrentSeverity: (annotation) => annotation.severity,
      setSeverity: (annotation, severity, setEditedAnnotation) => {
        setEditedAnnotation((prev) => ({ ...prev, severity }))
      },
    },
  ],
  [
    KestrelInspectionType.G1N6,
    {
      possibleValues: ['5', 'N/V'],
      headerText: 'Severity',
      getCurrentSeverity: (annotation) =>
        annotation.g1n6Annotation?.severity || '',
      setSeverity: (annotation, severity, setEditedAnnotation) => {
        setEditedAnnotation((prev) => ({
          ...prev,
          g1n6Annotation: {
            ...(prev.g1n6Annotation || new KVG1N6Annotation()),
            severity: severity,
          },
        }))
      },
    },
  ],
])

export const getSeverityConfiguration = (
  inspectionType: KestrelInspectionType
): SeverityConfiguration => {
  return (
    severityConfigurations.get(inspectionType) ||
    severityConfigurations.get(KestrelInspectionType.DEFAULT)!
  )
}
